import React from 'react';
import withAuthorization from 'components/Session/withAuthorization';
import { Typography } from '@material-ui/core';
import SectionFooter from 'views/SectionFooter';
import GuideHeader from '../../components/GuideHeader';
import GuideContent from '../../components/GuideContent';
import GuideSection from '../../components/GuideSection';
import DownloadGuideButton from './DownloadGuideButton';

const Exercise = () => {
  return (
    <>
      <GuideHeader
        name="Exercise"
        cdnId="app_images/exercise-db-row"
        text="Committing to this model and following the plan is essential to your success. It will help improve circulation, range of motion, alleviate daily aches & pains, sharpen awareness, while increasing strength and conditioning."
      />
      <GuideContent>
        <GuideSection>
          <Typography variant="h5" gutterBottom>
            ASSESSMENT INFORMATION
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            It’s important for you to understand a little about your body composition to help you set realistic goals.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            Three important numbers are used in your body composition: body weight, body fat mass and lean body mass.
            Your body fat mass is usually looked at as a body fat percentage (BF%): this is the percentage of body fat
            mass from your total body weight. A lower BF% is a good indicator of your health.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            Your body weight is the total of your body fat and your lean body mass (which includes not only your muscle
            mass also tissue, organs, bones, body water, etc…) It’s important that you focus on losing more body fat
            (lowering BF%) and not just weight, as you can see many aspects make up your total body weight.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            As you go through the program we will be working on increasing your muscle mass which will increase your
            lean body mass number.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            Remember when you increase your muscle mass you will be increasing your metabolism which will increase the
            burning of fat (this is what we all desire).
          </Typography>
        </GuideSection>

        <GuideSection>
          <Typography variant="h5" gutterBottom paragraph>
            TRAININGS
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            Schedule your workouts and commit to them (consistency is key).
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            No matter what your fitness level is following the series sequence of Mobility & Flexibility, Balance &
            Coordination then Core & Conditioning is recommended.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            Based on your level of conditioning and/or the time available to train, you can modify each days routine by
            doing fewer sets or circuits.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            Challenge yourself in your workouts, however, listen to your body and don’t over do it.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            Using proper form is essential to prevent injury.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            Increase your weights to keep the exercises challenging.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            Adjust your training intensity based on your progress.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            Active recovery days Mobility & Flexibility, Balance & Coordination then Core & Conditioning is recommended.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            Passive recovery days will be full rest days.
          </Typography>
        </GuideSection>

        <GuideSection>
          <Typography variant="h5" gutterBottom>
            ASSESSMENT
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            Fill out the assessment guide with measurements.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            Take starting pictures and progress pictures each month.
          </Typography>
          <Typography variant="body1" gutterBottom paragraph>
            Do your assessment every two weeks to track your progress.
          </Typography>
        </GuideSection>

        <DownloadGuideButton storagePath="guides/exercise-guide.pdf" type="Exercise" />
      </GuideContent>
      <SectionFooter />
    </>
  );
};

export default withAuthorization()(Exercise);
